import { render, staticRenderFns } from "./services-index-swiper.vue?vue&type=template&id=aae4bc10&"
import script from "./services-index-swiper.vue?vue&type=script&lang=js&"
export * from "./services-index-swiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ServicesItemSmallDesktop: require('/var/www/components/services/services-item-small-desktop.vue').default})
